import React from 'react'
import styled from 'styled-components'
import { FiCircle, FiTriangle, FiX } from 'react-icons/fi'
import { AvailabilityPropsType } from './Availability.types'
import { styleTheme } from '../../../../style/theme'

const Component: React.FC<AvailabilityPropsType> = ({ availability, className }) => {
  switch (availability) {
    case 'none':
      return <FiX className={className} data-availability={'none'} />
    case 'few':
      return <FiTriangle className={className} data-availability={'few'} />
    case 'lot':
      return <FiCircle className={className} data-availability={'lot'} />
  }
}

export const Availability = styled(Component)`
  &[data-availability='lot'] {
    color: ${styleTheme.colors.pink.base};
  }

  &[data-availability='few'] {
    color: ${styleTheme.colors.orange.base};
  }

  &[data-availability='none'] {
    color: ${styleTheme.colors.black};
  }
`
